export class TedBackUpRequest {
  /**
   * Site Id of the site the authorization is being requested for
   */
  public siteId?: number;

  /**
   * Registration ID
   */
  public registrationId?: number;

  /**
   * Challenge Key
   */
  public challengeKey?: string;

  /**
   * Username of the requestor
   */
  public username?: string;

  /**
   * Authorization count
   */
  public authorizationCount?: number;
}
